import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { UnidadeService } from 'src/app/services/unidade.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { Router, ActivatedRoute } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { UnidadeCadastro } from 'src/app/models/unidade-cadastro';
import { GenericValidator } from '../../../../../shared/validators/generic-validator.validator';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-unidade-create',
    templateUrl: './unidade-create.component.html',
    styleUrls: ['./unidade-create.component.css']
})
export class UnidadeCreateComponent implements OnInit {

    constructor(
        private formBuilder: FormBuilder,
        private unidadeService: UnidadeService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute) {}

    private currentUser: Auth;
    unidadeCadastro: UnidadeCadastro;

    unidadeFormGroup: FormGroup;

    public get form() {
        return this.unidadeFormGroup.controls;
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        // usar para criar / editar
        // validar se foi para esse componente com o id do centro de custo (sim = editar) (não = cadastrar)
        this.createForm(new UnidadeCadastro('', '', null));
    }

    createForm(unidadeCadastro: UnidadeCadastro) {
        this.unidadeFormGroup = this.formBuilder.group({
            nome: new FormControl(unidadeCadastro.nome, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            codigo: new FormControl(unidadeCadastro.codigo, [
                Validators.required,
                Validators.maxLength(15)
            ]),
            limite: new FormControl(unidadeCadastro.limite)
        });
    }

    onSubmit(unidadeCadastro: UnidadeCadastro) {
        if (this.unidadeFormGroup.valid) {
            this.unidadeService.add(unidadeCadastro, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.alertService.success(response.message, true);
                        this.router.navigate(['list'], { relativeTo: this.route.parent });
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                }
            );
        } else {
            GenericValidator.verifierValidatorsForm(this.unidadeFormGroup);
        }
    }

}
